export class Errors extends Error {
    constructor(private readonly messages: string[]) {
        const singleMessage = `${messages.join(`, `)}.`;
        super(singleMessage);
    }
}
